import React from 'react';
import {MasterLayout} from 'layout';
import {TuGiaiQuyetDon} from "modules/giai-quyet-don";

export default class TuGiaiQuyetDonPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TuGiaiQuyetDon params={this.props.params} fromTDTHGQD={this.props.route.name == 'theodoi'}/>
      </MasterLayout>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/giai-quyet-don/TuGiaiQuyetDonPage.jsx